import { HardeningView } from '@bartizo/shared';
import { z } from 'zod';
import { apiRequest } from './client.js';

/** What each fix Bartizo makes has come to on each server. */
export const getHardening = (): Promise<HardeningView> =>
  apiRequest('/hardening', { schema: HardeningView });

export const setHardeningAuto = (task: string, enabled: boolean): Promise<{ enabled: boolean }> =>
  apiRequest(`/hardening/${encodeURIComponent(task)}/auto`, {
    method: 'PUT',
    body: { enabled },
    schema: z.object({ enabled: z.boolean() }),
  });
